<template>
    <WalletAnnoucement/>
    <router-view v-if="init" :key="$route.fullPath"></router-view>
    <PaymentPolicy />
</template>

<script>
import { computed, defineAsyncComponent } from 'vue';
import { getWalletAuth} from '@template/utils';
import PaymentPolicy from '../components/PaymentPolicy.vue';
import WalletAnnoucement from '../components/WalletAnnoucement.vue';
export default {
    name: "WalletModule",
    data() {
        return {
            init: false,
            config: null,
        }
    },
    components: {
        PaymentPolicy,
        WalletAnnoucement
    },
    provide() {
        return {
            walletConfig : computed(() => this.config)
        }
    },
    created(){
        if(!this.$auth?.user?.isDemo){
            this.getWalletAuth();
        }else{
            this.$errorToast('Wallet access is restricted for demo users')
            this.$router.push({name:'Home'})
        }
    },
    methods:{
        async getWalletAuth(){
            try {
                let response = await getWalletAuth();
                if(response?.data){
                    this.config = response.data
                    this.init = true
                }
            } catch (error) {
                this.$errorToast(error)
            }
        },
    }
}
</script>